export function telpMask(str) {
  if (/^[^a-zA-Z]+$/.test(str)) {
    return str
  } else {
    return str.slice(0, -1)
  }
}

export function integerMask(str) {
  if (/^(\d+)$/.test(str)) {
    return str.replace(/^0+/, '')
  } else {
    if (str.length <= 1) {
      return '0'
    } else {
      return str.slice(0, -1)
    }
  }
}

export function decimalMask(str) {
  if (/^(\d+(\.)?(\d+)?)$/.test(str)) {
    return str
  } else {
    if (str.length <= 1) {
      return '0'
    } else {
     return str.slice(0, -1)
    }
  }
}

export function emailValidation(str) {
  return /^(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)$/.test(str)
}

export function unitMask(val, unit) {
  let str = val.split(' ')

  // check hanya angka
  if (!/\d+/.test(val)) {
    return ' '
  }

  // check whitespace
  if (/^\s/.test(val)) {
    return val.slice(1)
  }

  // check format #.#
  if (/^(\d+(\.)?(\d+)?)$/.test(str[0])) {
    let u = str[1] ? str[1].split(unit)[1] : ''
    if (u === undefined) {
      return `${str[0].slice(0, -1)} ${unit}`
    }
    return `${str[0]}${u} ${unit}`
  } else {
    if (/^(\d+\w+)$/) {
      return val.slice(0, -1)
    }
  }
}
